import { Prop, Component } from 'vue-property-decorator';
import AvatarDropdown from './AvatarDropdown.vue';
import NewsUpdateButton from './NewsUpdateButton.vue';
import EditorBase from '../editor/EditorBase';

@Component({
  components: {
    AvatarDropdown,
    NewsUpdateButton,
  },
})
export default class TopNav extends EditorBase {
  @Prop({ default: null })
  previousPage: string;

  @Prop({ default: false })
  showPreviousIcon: boolean;

  navigateBack() {
    if (!this.previousPage) {
      this.$router.back();
      return;
    }

    this.$router.push(this.previousPage);
  }

  get avatar(): string {
    return this.currentUser.avatar_url;
  }
}
